import React from 'react';

interface DashboardCardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  action?: React.ReactNode;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ children, className = '', title, action }) => (
  <div className={`bg-white rounded-lg border border-gray-200 shadow-sm ${className}`}>
    {(title || action) && (
      <div className="flex items-center justify-between px-5 pt-5 pb-3">
        {title && <h3 className="text-sm font-semibold text-gray-900">{title}</h3>}
        {action}
      </div>
    )}
    {children}
  </div>
);

export default DashboardCard;
